// import { LifeUserPolicies } from 'all-in-one-shared-api';
import { useEffect, useState } from 'react';
import { useKeycloakReady } from 'hooks';
import { useTranslation } from 'react-i18next';
import { isLocaleEnglish } from 'utils/languageUtils';
import KnowMoreArrowIcon from 'assets/images/home/chevron-right-red.svg';
import ChevronRight from 'assets/images/home/chevron-right.svg';
// import TooltipIcon from 'assets/images/policy/Tooltip.svg';
import Close from 'assets/images/liHome/close.svg';
import {
  Row,
  Col,
  Divider,
  // Card,
  Button,
  Grid,
  Switch,
  Modal,
  Typography,
} from 'antd';
import './PolicyDetail.less';
const { useBreakpoint } = Grid;
import { MyPolicies } from 'types/life';
import styled from 'styled-components';
import { formatSinglePolicy } from 'utils/liHome/formatPolicy';
import {
  useLifePolicyDetail,
  usePolicyDocCorrespondence,
  usePolicyCorrespondence,
  useRequestSubmission,
} from 'all-in-one-shared-api';
import PolicyBenefit from './PolicyBenefit';
import Beneficiaries from './Beneficiaries';
import ManagePayment from './ManagePayment';
import AdInfo from './AdInfo';
import { useNavigate } from 'react-router-dom';
import _ from 'lodash';
import { changeDataFun } from 'utils/formate';
const { Title, Text } = Typography;

type PolicyDetailProps = {
  policy: MyPolicies;
};
interface PdRowProps {
  paddingFlag?: string;
  padB?: string;
}
interface DividerLineProps {
  padB?: string;
}
const StyledBlock = styled.div`
  width: 100%;
  background: #fff;
  margin-bottom: 1rem;
`;
const Androw = styled(Row)<PdRowProps>`
  max-width: 672px;
  margin: 0 auto;
  padding-top: ${(props) => (props.paddingFlag ? props.paddingFlag : `0`)};
  padding-bottom: ${(props) => (props.padB ? props.padB : `0`)};
`;
const AndCol = styled(Col)`
  margin: 0 16px;
`;
const AntDivider = styled(Divider)`
  border-color: #cccccc;
`;
const KnowMoreLinkImage = styled.img`
  margin-left: 12px;
  width: 14px;
  height: 8px;
`;
const DividerLine = ({ padB }: DividerLineProps) => {
  return (
    <Androw justify="start" padB={padB}>
      <AndCol style={{ width: '100%' }}>
        <AntDivider style={{ margin: '12px 0' }}></AntDivider>
      </AndCol>
    </Androw>
  );
};

const PolicyDetail = ({ policy }: PolicyDetailProps) => {
  const { t, i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const { token } = useKeycloakReady();
  const { xs, lg } = useBreakpoint();
  const [corresExist, setCorresExist] = useState(false);
  const singlePolicy = formatSinglePolicy(policy, isEnglish);
  const [swichStatus, setSwichStatus] = useState<boolean>(false);
  // const [enoticeShow, setEnoticeShow] = useState(false);
  const [randoms, setRandoms] = useState(Math.random());

  const { shouldFetch: detailFetch, data: detailData } = useLifePolicyDetail(
    'policy-detail' + randoms,
    token ?? '',
    policy.policyNumber,
    policy.companyCode,
    'Y',
  );
  const { shouldFetch: policyCorrFetch, data: policyCorrFetchData } = usePolicyCorrespondence(
    'usePolicyCorrespondence',
    token ?? '',
    policy.policyNumber,
    policy.companyCode,
    '',
    '',
    0,
    5,
  );
  const { shouldFetch: docFetch, data: docData } = usePolicyDocCorrespondence(
    'usePolicyDocCorrespondence',
    token ?? '',
    policy.policyNumber,
    policy.companyCode,
    '',
    '',
  );
  const { shouldFetch: shouldRequestFetch } = useRequestSubmission(
    {
      name: 'request-submission',
      params: {
        fieldChanges: [{ changedValue: ['Y'], key: 'changeEcoress', originalValue: ['N'] }],
        changeType: '05',
        uploadFlag: false,
        companyCode: policy.companyCode,
        policyNo: policy.policyNumber,
      },
    },
    token ?? '',
    {
      fieldChanges: [{ changedValue: ['Y'], key: 'eCorrepondence', originalValue: ['N'] }],
      changeType: '05',
      uploadFlag: false,
      companyCode: policy.companyCode,
      policyNo: policy.policyNumber,
    },
    {
      shouldRetryOnError: false,
      onSuccess: (data) => {
        shouldRequestFetch(false);
        setSwichStatus(true);
        // setEnoticeShow(false);
        navigate('/GreenSuccessPage', {
          state: {
            policyNo: policy.policyNumber,
            backRoute: '/LIPolicies',
            enquiryReference: data.bpmReferenceNo,
          },
        });
      },
      onError: () => {
        // if (error) {
        //   setShowError(true);
        // }

        shouldRequestFetch(false);
        navigate('/ChangeRequestError', {
          replace: true,
        });
      },
    },
  );
  const navigate = useNavigate();
  useEffect(() => {
    if (
      // policy?.planCode != 'UN1' &&
      // policy?.planCode != 'TNB' &&
      (docData?.policyDocumentData && docData?.policyDocumentData?.filter((item) => !_.isEmpty(item)).length > 0) ||
      (policyCorrFetchData && policyCorrFetchData?.length > 0)
    ) {
      setCorresExist(true);
    } else setCorresExist(false);
  }, [policyCorrFetchData, docData, policy.planCode]);

  // useEffect(() => {
  //   if (detailData) {
  //     setEnoticeShow(detailData.enotices);
  //   }
  // }, [detailData]);

  useEffect(() => {
    setRandoms(Math.random());
    detailFetch(true);
    docFetch(true);
    policyCorrFetch(true);
    // eslint-disable-next-line
  }, []);
  const changRS = () => {
    //changeRequestStatus
    navigate('/MakeRequestPage', {
      state: {
        tabs: 1,
        policyNo: policy.policyNumber,
        companyCode: policy.companyCode,
      },
    });
  };
  const changCN = () => {
    //make a claim
    navigate('/ClaimEnquiryPage', {
      state: {
        tabs: 0,
        policyNo: policy.policyNumber,
      },
    });
  };
  const toEditInfo = () => {
    //ChangeContactInformation
    navigate('/ChangeContactInformation', {
      state: {
        policyNo: policy.policyNumber,
      },
    });
  };
  const viewPolicyCorrespondence = () => {
    navigate('/PoliciesCorrespondence', {
      state: {
        policyNo: policy.policyNumber,
        companyCode: policy.companyCode,
      },
    });
  };
  const SwitchonChange = (checked: boolean) => {
    setSwichStatus(checked);
  };
  const openSwitchStatus = () => {
    shouldRequestFetch(true);
    console.log(swichStatus);
  };
  return (
    <div className="policy-detail-wrap">
      <StyledBlock className="base-detail">
        <Androw justify="start" paddingFlag="40px">
          <AndCol className="font-setting500 font-size17 grey-font ">
            {t('life.policies.date', {
              date: isEnglish ? detailData?.policyDataDate : changeDataFun(detailData?.policyDataDate),
            })}
          </AndCol>
          <AntDivider style={{ margin: '12px 0' }}></AntDivider>
        </Androw>
        <Androw justify="start">
          <AndCol className="font-setting500 font-size17 grey-font ">{singlePolicy?.productCategoryTitle}</AndCol>
        </Androw>
        <Androw justify="start">
          <AndCol className="font-size33">{singlePolicy?.productName}</AndCol>
        </Androw>
        <Androw justify="start">
          <AndCol>
            <span
              className={`status ${
                singlePolicy?.colour == 'GREEN' ? 'success' : singlePolicy?.colour == 'RED' ? 'failB' : 'over'
              }`}
            >
              {singlePolicy?.policyStatus}
            </span>
          </AndCol>
        </Androw>
        {!!singlePolicy?.alertState && detailData?.hiddenNewPolIssAlertFlag != 'Y' && (
          <Androw justify="start">
            <AndCol style={{ width: '100%' }}>
              <div
                className="show-status"
                style={{
                  backgroundColor: `${singlePolicy?.alertStateCode == 'Issued' ? '#F2FBE9' : ' #FDEEEC'}`,
                  color: `${singlePolicy?.alertStateCode == 'Issued' ? '#549736' : '#E9573D'}`,
                }}
              >
                {singlePolicy?.alertState}
              </div>
            </AndCol>
          </Androw>
        )}
        {!!singlePolicy?.alertPolicyUpdateStateCode && (
          <Androw justify="start">
            <AndCol style={{ width: '100%' }}>
              <div
                className="show-status"
                style={{
                  backgroundColor: '#FDEEEC',
                  color: '#E9573D',
                }}
              >
                {singlePolicy?.alertPolicyUpdateStateName}
              </div>
            </AndCol>
          </Androw>
        )}
        <DividerLine></DividerLine>
        <Androw justify="start">
          <AndCol style={{ width: '100%' }}>
            <div className="tagging">
              <span className="font-size20">{t('life.home.insured')}</span>
              <span className="font-size20 font-setting500" style={{ wordWrap: 'break-word' }}>
                {singlePolicy?.insuredName}
              </span>
            </div>
          </AndCol>
        </Androw>
        <DividerLine></DividerLine>
        <Androw justify="start">
          <AndCol lg={9} md={9} sm={8} xs={8}>
            <div className="tagging">
              <span className="font-size20">{t('life.home.pnumber')}</span>
              <span className="font-size20 font-setting500" style={{ wordWrap: 'break-word' }}>
                {singlePolicy?.policyNumber}
              </span>
            </div>
          </AndCol>
          <AndCol span={1}>
            <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
          </AndCol>
          <AndCol lg={9} md={9} sm={8} xs={8}>
            <div className="tagging">
              <span className="font-size20">{t('life.home.policydate')}</span>
              <span className="font-size20 font-setting500" style={{ wordWrap: 'break-word' }}>
                {isEnglish ? detailData?.policyDate : changeDataFun(detailData?.policyDate)}
              </span>
            </div>
          </AndCol>
        </Androw>
        {/* <Androw justify="start">
          <AndCol lg={9} md={9} sm={8} xs={8}>
            <div className="tagging">
              <span className="font-size20">{t('life.home.insured')}</span>
              <span className="font-size20 font-setting500" style={{ wordWrap: 'break-word' }}>
                {singlePolicy?.insuredName}
              </span>
            </div>
          </AndCol>
          <AndCol span={1}>
            <AntDivider type="vertical" style={{ height: '100%' }}></AntDivider>
          </AndCol>
          <AndCol lg={9} md={9} sm={8} xs={8}>
            <div className="tagging">
              <span className="font-size20">{t('life.home.pnumber')}</span>
              <span className="font-size20 font-setting500" style={{ wordWrap: 'break-word' }}>
                {singlePolicy?.policyNumber}
              </span>
            </div>
          </AndCol>
        </Androw> */}
        <DividerLine padB="30px"></DividerLine>
      </StyledBlock>
      <StyledBlock style={{ paddingBottom: '8px' }}>
        <Androw justify="start" paddingFlag="24px">
          <AndCol className="font-size33">{t('life.policies.information')}</AndCol>
          <AntDivider style={{ margin: '8px 0' }}></AntDivider>
        </Androw>
        <Androw justify="start">
          <AndCol className="font-size26 grey-font">{t('life.policies.aboutThePolicyholder')}</AndCol>
        </Androw>
        <DividerLine></DividerLine>
        <Androw justify="start">
          <AndCol>
            <div className="tagging">
              <span className="font-size17 font-setting500 grey-font">{t('life.policies.policyInformationName')}</span>
              <span className="font-size20 ">
                {(detailData?.policyHolderInformation?.givenName || '') +
                  ' ' +
                  (detailData?.policyHolderInformation?.surname || '')}
              </span>
            </div>
          </AndCol>
        </Androw>
        <DividerLine></DividerLine>
        <Androw justify="start">
          <AndCol>
            <div className="tagging">
              <span className="font-size17 font-setting500 grey-font">{t('life.policies.policyInformationEmail')}</span>
              <span className="font-size20 ">{detailData?.policyHolderInformation?.email || ''}</span>
            </div>
          </AndCol>
        </Androw>
        <DividerLine></DividerLine>
        <Androw justify="start">
          <AndCol>
            <div className="tagging">
              <span className="font-size17 font-setting500 grey-font">
                {t('life.policies.policyInformationMobileNumber')}
              </span>
              <span className="font-size20 ">
                {(detailData?.policyHolderInformation?.mobilePhoneCountryCode || '') +
                  ' ' +
                  (detailData?.policyHolderInformation?.mobileNumber || '')}
              </span>
            </div>
          </AndCol>
        </Androw>
        <DividerLine></DividerLine>
        {(singlePolicy?.policyStatusCode == 'MP' ||
          singlePolicy?.policyStatusCode == 'IF' ||
          singlePolicy?.policyStatusCode == 'AP') && (
          <Androw
            justify="center"
            style={{
              height: '49px',
            }}
          >
            <AndCol style={{ cursor: 'pointer' }} onClick={toEditInfo}>
              <div className="view-info">
                <span className="font-setting500 font-size17 red-font">
                  {t('life.policies.ChangeContactInformation')}
                </span>
                <KnowMoreLinkImage src={KnowMoreArrowIcon} alt="know-more-arrow" />
              </div>
            </AndCol>
          </Androw>
        )}
      </StyledBlock>
      {detailData?.benefitData && detailData?.benefitData.length > 0 && (
        <PolicyBenefit
          benefit={detailData?.benefitData}
          policyNo={policy.policyNumber}
          companyCode={policy.companyCode}
          planCode={policy.planCode}
        ></PolicyBenefit>
      )}
      <Beneficiaries
        beneficiaries={detailData?.beneficiariesData}
        policyNo={policy.policyNumber}
        companyCode={policy.companyCode}
        policyStatusCode={singlePolicy?.policyStatusCode}
      ></Beneficiaries>
      <ManagePayment
        salesUnitCode={policy?.salesUnitCode}
        policyStatusCode={singlePolicy?.policyStatusCode}
        alertStateCode={singlePolicy?.alertStateCode}
        hiddenChangePaymentFlag={detailData?.hiddenChangePaymentFlag}
        policyNo={policy.policyNumber}
      ></ManagePayment>
      <StyledBlock style={{ paddingBottom: '8px' }}>
        <Androw justify="start" paddingFlag="24px">
          <AndCol className="font-size26">{t('life.policies.RequestStatus')}</AndCol>
        </Androw>
        <Androw justify="center" paddingFlag="24px" padB="24px">
          <AndCol className="font-size26 change-status ">
            <Button className="red-font font-size20 font-setting500 status-btn" onClick={changRS}>
              {t('life.policies.CheckRequestStatus')}
            </Button>
          </AndCol>
        </Androw>
      </StyledBlock>
      {corresExist && (
        <StyledBlock style={{ marginBottom: detailData?.enotices ? 0 : '1rem' }}>
          <Androw
            justify="space-between"
            onClick={viewPolicyCorrespondence}
            align="middle"
            paddingFlag={detailData?.enotices ? '24px' : '12px'}
            padB={detailData?.enotices ? '0' : '12px'}
            style={{ cursor: 'pointer' }}
          >
            <AndCol className="font-size26">{t('life.policies.PolicyCorrespondence')}</AndCol>
            <AndCol>
              <img src={ChevronRight} alt="" />
            </AndCol>
          </Androw>
        </StyledBlock>
      )}
      {detailData?.enotices && (
        <StyledBlock style={{ paddingBottom: '8px', marginTop: 0 }}>
          {corresExist && <DividerLine></DividerLine>}
          <Androw
            justify="space-between"
            align="middle"
            style={{ paddingTop: corresExist ? 0 : '8px', cursor: 'pointer' }}
          >
            <AndCol className="font-size17 font-setting500 green-font">
              {t('life.policies.GoGreen')} <Switch onChange={SwitchonChange} checked={swichStatus} />
            </AndCol>
            <AndCol>{/* <img src={TooltipIcon} alt="" /> */}</AndCol>
          </Androw>
        </StyledBlock>
      )}

      {(singlePolicy?.policyStatusCode == 'MP' ||
        singlePolicy?.policyStatusCode == 'IF' ||
        singlePolicy?.policyStatusCode == 'AP') && (
        <StyledBlock style={{ paddingBottom: '8px' }}>
          <Androw justify="start" paddingFlag="24px">
            <AndCol className="font-size26">{t('life.policies.ClaimsNotifications')}</AndCol>
          </Androw>
          <Androw justify="center" paddingFlag="24px" padB="24px">
            <AndCol className="font-size26 change-status ">
              <Button className="red-font font-size20 font-setting500 status-btn" onClick={changCN}>
                {t('life.policies.MakeClaimNotification')}
              </Button>
            </AndCol>
          </Androw>
        </StyledBlock>
      )}
      <AdInfo adinfo={detailData?.consultant} salesUnitCode={policy?.salesUnitCode}></AdInfo>
      <Modal
        okText={t('life.policies.ConfirmEnoticesYes')}
        cancelText={t('life.policies.ConfirmEnoticesNo')}
        open={swichStatus}
        onCancel={() => setSwichStatus(false)}
        className="e-notice-modal"
        width={xs ? 'calc(100% - 32px)' : '510px'}
        closeIcon={<img src={Close} />}
        onOk={openSwitchStatus}
      >
        <div>
          <Title level={5} className={`red-font ${lg ? 'font-size26' : 'font-size22'}`}>
            {t('life.policies.confirmGreen')}
          </Title>
          <Text className={`${lg ? 'font-size22' : 'font-size17'}`}>{t('life.policies.confirmGreenDesc')}</Text>
        </div>
      </Modal>
    </div>
  );
};
export default PolicyDetail;
